import { black, blue, blue_100, blue_1000, blue_150, blue_200, blue_300, blue_400, blue_500, blue_600, blue_700, blue_800, blue_900, color_cortex, color_panw, color_prisma, color_strata, color_unit42, cyan, cyan_100, cyan_1000, cyan_200, cyan_300, cyan_400, cyan_500, cyan_600, cyan_700, cyan_800, cyan_900, gray, gray_100, gray_1000, gray_1025, gray_1050, gray_200, gray_300, gray_400, gray_50, gray_500, gray_600, gray_700, gray_800, gray_900, gray_950, green, green_100, green_1000, green_200, green_300, green_400, green_500, green_600, green_700, green_800, green_900, highlight_callout_dark, highlight_callout_light, highlight_empty_data_dark, highlight_empty_data_light, highlight_neutral_dark, highlight_neutral_light, indigo, indigo_100, indigo_1000, indigo_200, indigo_300, indigo_400, indigo_500, indigo_600, indigo_700, indigo_800, indigo_900, indigo_magenta_100, indigo_magenta_1000, indigo_magenta_1100, indigo_magenta_1200, indigo_magenta_1300, indigo_magenta_1400, indigo_magenta_1500, indigo_magenta_1600, indigo_magenta_1700, indigo_magenta_1800, indigo_magenta_200, indigo_magenta_300, indigo_magenta_400, indigo_magenta_500, indigo_magenta_600, indigo_magenta_700, indigo_magenta_800, indigo_magenta_900, lime, lime_100, lime_1000, lime_200, lime_300, lime_400, lime_500, lime_600, lime_700, lime_800, lime_900, magenta, magenta_100, magenta_1000, magenta_200, magenta_300, magenta_400, magenta_500, magenta_600, magenta_700, magenta_800, magenta_900, orange, orange_100, orange_1000, orange_200, orange_300, orange_400, orange_500, orange_600, orange_700, orange_800, orange_900, pink, pink_100, pink_1000, pink_200, pink_300, pink_400, pink_500, pink_600, pink_700, pink_800, pink_900, purple, purple_100, purple_1000, purple_200, purple_300, purple_400, purple_500, purple_600, purple_700, purple_800, purple_900, purple_magenta_100, purple_magenta_1000, purple_magenta_1100, purple_magenta_1200, purple_magenta_1300, purple_magenta_1400, purple_magenta_1500, purple_magenta_1600, purple_magenta_200, purple_magenta_300, purple_magenta_400, purple_magenta_500, purple_magenta_600, purple_magenta_700, purple_magenta_800, purple_magenta_900, purple_teal_100, purple_teal_1000, purple_teal_1100, purple_teal_1200, purple_teal_1300, purple_teal_1400, purple_teal_1500, purple_teal_1600, purple_teal_1700, purple_teal_1800, purple_teal_200, purple_teal_300, purple_teal_400, purple_teal_500, purple_teal_600, purple_teal_700, purple_teal_800, purple_teal_900, red, red_100, red_1000, red_200, red_300, red_400, red_500, red_600, red_700, red_800, red_900, red_yellow_100, red_yellow_1000, red_yellow_1100, red_yellow_1200, red_yellow_1300, red_yellow_1400, red_yellow_1500, red_yellow_1600, red_yellow_200, red_yellow_300, red_yellow_400, red_yellow_500, red_yellow_600, red_yellow_700, red_yellow_800, red_yellow_900, sky, sky_100, sky_1000, sky_200, sky_300, sky_400, sky_500, sky_600, sky_700, sky_800, sky_900, sky_red_100, sky_red_1000, sky_red_1100, sky_red_1200, sky_red_1300, sky_red_1400, sky_red_1500, sky_red_1600, sky_red_1700, sky_red_1800, sky_red_200, sky_red_300, sky_red_400, sky_red_500, sky_red_600, sky_red_700, sky_red_800, sky_red_900, sky_teal_100, sky_teal_1000, sky_teal_1100, sky_teal_1200, sky_teal_1300, sky_teal_1400, sky_teal_1500, sky_teal_1600, sky_teal_200, sky_teal_300, sky_teal_400, sky_teal_500, sky_teal_600, sky_teal_700, sky_teal_800, sky_teal_900, steel_gray, steel_gray_100, steel_gray_1000, steel_gray_1100, steel_gray_1150, steel_gray_150, steel_gray_200, steel_gray_300, steel_gray_400, steel_gray_50, steel_gray_500, steel_gray_600, steel_gray_700, steel_gray_800, steel_gray_850, steel_gray_900, steel_gray_950, teal, teal_100, teal_1000, teal_200, teal_300, teal_400, teal_500, teal_600, teal_700, teal_800, teal_900, teal_orange_100, teal_orange_1000, teal_orange_1100, teal_orange_1200, teal_orange_1300, teal_orange_1400, teal_orange_1500, teal_orange_1600, teal_orange_1700, teal_orange_1800, teal_orange_200, teal_orange_300, teal_orange_400, teal_orange_500, teal_orange_600, teal_orange_700, teal_orange_800, teal_orange_900, white, yellow, yellow_100, yellow_1000, yellow_200, yellow_300, yellow_400, yellow_500, yellow_600, yellow_700, yellow_800, yellow_900 } from '@panwds/constants';
const dataVisColors = {
    ['red-yellow']: {
        100: red_yellow_100,
        200: red_yellow_200,
        300: red_yellow_300,
        400: red_yellow_400,
        500: red_yellow_500,
        600: red_yellow_600,
        700: red_yellow_700,
        800: red_yellow_800,
        900: red_yellow_900,
        1000: red_yellow_1000,
        1100: red_yellow_1100,
        1200: red_yellow_1200,
        1300: red_yellow_1300,
        1400: red_yellow_1400,
        1500: red_yellow_1500,
        1600: red_yellow_1600
    },
    ['purple-magenta']: {
        100: purple_magenta_100,
        200: purple_magenta_200,
        300: purple_magenta_300,
        400: purple_magenta_400,
        500: purple_magenta_500,
        600: purple_magenta_600,
        700: purple_magenta_700,
        800: purple_magenta_800,
        900: purple_magenta_900,
        1000: purple_magenta_1000,
        1100: purple_magenta_1100,
        1200: purple_magenta_1200,
        1300: purple_magenta_1300,
        1400: purple_magenta_1400,
        1500: purple_magenta_1500,
        1600: purple_magenta_1600
    },
    ['sky-teal']: {
        100: sky_teal_100,
        200: sky_teal_200,
        300: sky_teal_300,
        400: sky_teal_400,
        500: sky_teal_500,
        600: sky_teal_600,
        700: sky_teal_700,
        800: sky_teal_800,
        900: sky_teal_900,
        1000: sky_teal_1000,
        1100: sky_teal_1100,
        1200: sky_teal_1200,
        1300: sky_teal_1300,
        1400: sky_teal_1400,
        1500: sky_teal_1500,
        1600: sky_teal_1600
    },
    ['sky-red']: {
        100: sky_red_100,
        200: sky_red_200,
        300: sky_red_300,
        400: sky_red_400,
        500: sky_red_500,
        600: sky_red_600,
        700: sky_red_700,
        800: sky_red_800,
        900: sky_red_900,
        1000: sky_red_1000,
        1100: sky_red_1100,
        1200: sky_red_1200,
        1300: sky_red_1300,
        1400: sky_red_1400,
        1500: sky_red_1500,
        1600: sky_red_1600,
        1700: sky_red_1700,
        1800: sky_red_1800
    },
    ['indigo-magenta']: {
        100: indigo_magenta_100,
        200: indigo_magenta_200,
        300: indigo_magenta_300,
        400: indigo_magenta_400,
        500: indigo_magenta_500,
        600: indigo_magenta_600,
        700: indigo_magenta_700,
        800: indigo_magenta_800,
        900: indigo_magenta_900,
        1000: indigo_magenta_1000,
        1100: indigo_magenta_1100,
        1200: indigo_magenta_1200,
        1300: indigo_magenta_1300,
        1400: indigo_magenta_1400,
        1500: indigo_magenta_1500,
        1600: indigo_magenta_1600,
        1700: indigo_magenta_1700,
        1800: indigo_magenta_1800
    },
    ['teal-orange']: {
        100: teal_orange_100,
        200: teal_orange_200,
        300: teal_orange_300,
        400: teal_orange_400,
        500: teal_orange_500,
        600: teal_orange_600,
        700: teal_orange_700,
        800: teal_orange_800,
        900: teal_orange_900,
        1000: teal_orange_1000,
        1100: teal_orange_1100,
        1200: teal_orange_1200,
        1300: teal_orange_1300,
        1400: teal_orange_1400,
        1500: teal_orange_1500,
        1600: teal_orange_1600,
        1700: teal_orange_1700,
        1800: teal_orange_1800
    },
    ['purple-teal']: {
        100: purple_teal_100,
        200: purple_teal_200,
        300: purple_teal_300,
        400: purple_teal_400,
        500: purple_teal_500,
        600: purple_teal_600,
        700: purple_teal_700,
        800: purple_teal_800,
        900: purple_teal_900,
        1000: purple_teal_1000,
        1100: purple_teal_1100,
        1200: purple_teal_1200,
        1300: purple_teal_1300,
        1400: purple_teal_1400,
        1500: purple_teal_1500,
        1600: purple_teal_1600,
        1700: purple_teal_1700,
        1800: purple_teal_1800
    },
    ['categorical-set-1']: {
        1: sky_500,
        2: orange_400,
        3: teal_400,
        4: purple_500,
        5: yellow_300,
        6: magenta_600,
        7: cyan_300,
        8: green_500,
        9: pink_500,
        10: indigo_600,
        11: lime_400,
        12: red_500
    },
    ['categorical-set-2']: {
        1: teal_400,
        2: orange_400,
        3: purple_500,
        4: magenta_600,
        5: indigo_600,
        6: yellow_300,
        7: green_500,
        8: cyan_300,
        9: pink_500,
        10: lime_400,
        11: red_500,
        12: sky_500
    }
};
export const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    inherit: 'inherit',
    black,
    white,
    gray: {
        DEFAULT: gray,
        50: gray_50,
        100: gray_100,
        200: gray_200,
        300: gray_300,
        400: gray_400,
        500: gray_500,
        600: gray_600,
        700: gray_700,
        800: gray_800,
        900: gray_900,
        950: gray_950,
        1000: gray_1000,
        1025: gray_1025,
        1050: gray_1050
    },
    red: {
        DEFAULT: red,
        100: red_100,
        200: red_200,
        300: red_300,
        400: red_400,
        500: red_500,
        600: red_600,
        700: red_700,
        800: red_800,
        900: red_900,
        1000: red_1000
    },
    orange: {
        DEFAULT: orange,
        100: orange_100,
        200: orange_200,
        300: orange_300,
        400: orange_400,
        500: orange_500,
        600: orange_600,
        700: orange_700,
        800: orange_800,
        900: orange_900,
        1000: orange_1000
    },
    yellow: {
        DEFAULT: yellow,
        100: yellow_100,
        200: yellow_200,
        300: yellow_300,
        400: yellow_400,
        500: yellow_500,
        600: yellow_600,
        700: yellow_700,
        800: yellow_800,
        900: yellow_900,
        1000: yellow_1000
    },
    teal: {
        DEFAULT: teal,
        100: teal_100,
        200: teal_200,
        300: teal_300,
        400: teal_400,
        500: teal_500,
        600: teal_600,
        700: teal_700,
        800: teal_800,
        900: teal_900,
        1000: teal_1000
    },
    blue: {
        DEFAULT: blue,
        100: blue_100,
        150: blue_150,
        200: blue_200,
        300: blue_300,
        400: blue_400,
        500: blue_500,
        600: blue_600,
        700: blue_700,
        800: blue_800,
        900: blue_900,
        1000: blue_1000
    },
    lime: {
        DEFAULT: lime,
        light: lime_200,
        dark: lime_500,
        100: lime_100,
        200: lime_200,
        300: lime_300,
        400: lime_400,
        500: lime_500,
        600: lime_600,
        700: lime_700,
        800: lime_800,
        900: lime_900,
        1000: lime_1000
    },
    green: {
        DEFAULT: green,
        light: green_200,
        dark: green_500,
        100: green_100,
        200: green_200,
        300: green_300,
        400: green_400,
        500: green_500,
        600: green_600,
        700: green_700,
        800: green_800,
        900: green_900,
        1000: green_1000
    },
    cyan: {
        DEFAULT: cyan,
        light: cyan_200,
        dark: cyan_400,
        100: cyan_100,
        200: cyan_200,
        300: cyan_300,
        400: cyan_400,
        500: cyan_500,
        600: cyan_600,
        700: cyan_700,
        800: cyan_800,
        900: cyan_900,
        1000: cyan_1000
    },
    sky: {
        DEFAULT: sky,
        light: sky_300,
        dark: sky_500,
        100: sky_100,
        200: sky_200,
        300: sky_300,
        400: sky_400,
        500: sky_500,
        600: sky_600,
        700: sky_700,
        800: sky_800,
        900: sky_900,
        1000: sky_1000
    },
    indigo: {
        DEFAULT: indigo,
        light: indigo_300,
        dark: indigo_600,
        100: indigo_100,
        200: indigo_200,
        300: indigo_300,
        400: indigo_400,
        500: indigo_500,
        600: indigo_600,
        700: indigo_700,
        800: indigo_800,
        900: indigo_900,
        1000: indigo_1000
    },
    purple: {
        DEFAULT: purple,
        light: purple_200,
        dark: purple_600,
        100: purple_100,
        200: purple_200,
        300: purple_300,
        400: purple_400,
        500: purple_500,
        600: purple_600,
        700: purple_700,
        800: purple_800,
        900: purple_900,
        1000: purple_1000
    },
    pink: {
        DEFAULT: pink,
        light: pink_200,
        dark: pink_600,
        100: pink_100,
        200: pink_200,
        300: pink_300,
        400: pink_400,
        500: pink_500,
        600: pink_600,
        700: pink_700,
        800: pink_800,
        900: pink_900,
        1000: pink_1000
    },
    magenta: {
        DEFAULT: magenta,
        light: magenta_300,
        dark: magenta_700,
        100: magenta_100,
        200: magenta_200,
        300: magenta_300,
        400: magenta_400,
        500: magenta_500,
        600: magenta_600,
        700: magenta_700,
        800: magenta_800,
        900: magenta_900,
        1000: magenta_1000
    },
    ['blue-steel']: {
        DEFAULT: '#9AA5B2',
        100: '#F0F4F7',
        200: '#DFE5EB',
        300: '#B8C1CC',
        400: '#9AA5B2',
        500: '#768494',
        600: '#5D6A7A',
        700: '#475566',
        800: '#354252',
        900: '#19222E',
        950: '#10171F',
        1000: '#0B1117'
    },
    ['steel-blue']: {
        DEFAULT: '#9AA5B2',
        100: '#F0F4F7',
        200: '#DFE5EB',
        300: '#B8C1CC',
        400: '#9AA5B2',
        500: '#768494',
        600: '#5D6A7A',
        700: '#475566',
        800: '#354252',
        900: '#19222E',
        950: '#10171F',
        1000: '#0B1117'
    },
    ['steel-gray']: {
        DEFAULT: steel_gray,
        50: steel_gray_50,
        100: steel_gray_100,
        150: steel_gray_150,
        200: steel_gray_200,
        300: steel_gray_300,
        400: steel_gray_400,
        500: steel_gray_500,
        600: steel_gray_600,
        700: steel_gray_700,
        800: steel_gray_800,
        850: steel_gray_850,
        900: steel_gray_900,
        950: steel_gray_950,
        1000: steel_gray_1000,
        1100: steel_gray_1100,
        1150: steel_gray_1150
    },
    panw: color_panw,
    strata: color_strata,
    prisma: color_prisma,
    cortex: color_cortex,
    unit42: color_unit42,
    ['highlight-neutral']: {
        dark: highlight_neutral_dark,
        light: highlight_neutral_light
    },
    ['highlight-callout']: {
        dark: highlight_callout_dark,
        light: highlight_callout_light
    },
    ['highlight-empty']: {
        dark: highlight_empty_data_dark,
        light: highlight_empty_data_light
    },
    ...dataVisColors
};
//# sourceMappingURL=color.js.map